<template>
    <v-card
        class="elevation-0 mb-4"
        width="89vw"
        :max-width="$vuetify.breakpoint.mdAndUp ? '450px' : '100%'"
     >
        <loading-overlay :loading="loading"></loading-overlay>
        <template v-if="!loading && postersBeneficiary">
            <template v-if="!showCarousel">
                <v-card-text id="scroller">
                    <div class="px-sm-6 pb-6 pt-0">
                        <v-alert
                            v-if="acceptedOrder.type === 'hybrid'"
                            type="warning"
                            class="body-2"
                            text
                            dense
                        >
                            Please view disclaimer
                            <a
                                class="text-decoration-underline"
                                @click="showVirtualOrderDisclaimer = true"
                            >
                                here
                            </a>
                        </v-alert>

                        <!-- Sending Amount -->
                        <v-row class="mt-3" v-if="acceptedOrder.type === 'hybrid' || acceptedOrder.type === 'p2p'">
                            <v-col class="text-center">
                                <v-img :src="$store.state.user.avatar || '/svg/man.svg'" tile class="mx-auto avatar" />
                                <p class="transfer-overline overline blue-grey--text lighten-4 mb-0">
                                    You send
                                </p>
                                <!--
                                <span class="caption font-italic font-weight-bold red--text">(Note: this is the total amount including fees)</span> -->
                            </v-col>
                            <v-col class="text-center px-0" cols="1" col-sm="2">
                                <v-img src="/images/triple-arrow.png" tile class="mx-auto arrows" contain />
                            </v-col>
                            <v-col class="text-center" v-if="postersBeneficiary">
                                <template v-if="acceptedOrder.order.type === 'p2p'">
                                    <v-img :src="postersBeneficiary.avatar || '/svg/man.svg'" tile class="mx-auto avatar" />
                                    <p
                                        class="transfer-overline overline blue-grey--text lighten-4 mb-0"
                                        :style="[ $vuetify.breakpoint.mdAndUp ? { whiteSpace: 'nowrap' } : {
                                            lineHeight: '20px',
                                            wordBreak: 'break-word',
                                            whiteSpace: 'unset'
                                        }]"
                                    >
                                        {{ posterBeneficiaryFirstName }} gets
                                    </p>
                                </template>

                                <template v-if="acceptedOrder.order.type === 'hybrid'">
                                    <v-img :src="$store.state.user.avatar || '/svg/man.svg'" tile class="mx-auto avatar" />
                                    <p
                                        class="transfer-overline overline blue-grey--text lighten-4 mb-0"
                                        :style="[ $vuetify.breakpoint.mdAndUp ? { whiteSpace: 'nowrap' } : {
                                            lineHeight: '20px',
                                            wordBreak: 'break-word',
                                            whiteSpace: 'unset'
                                        }]"
                                    >
                                        {{ $store.state.user.firstname }} gets
                                    </p>
                                </template>

                                <p class="headline font-weight-medium mb-0">
                                    {{ acceptedOrder.type === 'p2p' ? totalAmount : subtotalInPbCurrency }}
                                    <span class="subtitle-2 font-weight-regular teal--text lighten-1">
                                        {{ acceptedOrder.type === 'p2p' ? acceptedOrder.matcher_currency : acceptedOrder.pb_currency}}
                                    </span>
                                </p>
                            </v-col>
                        </v-row>
                        <v-row
                            v-else-if="acceptedOrder && acceptedOrder.matcher_fee && acceptedOrder.type !== 'hybrid'"
                            class="text-center"
                        >
                            <v-col>
                                <p class="font-weight-bold title">YOU ARE TO SEND</p>
                                <div class="d-sm-flex d-block justify-center">
                                    <p class="my-0 red--text flashing-text" color="red" style="font-size: 45px">
                                        {{getCurrencySymbol(acceptedOrder.matcher_currency)}}{{totalAmount}}
                                    </p>
                                    <v-btn @click="copyToClipboard(totalAmount)" class="mt-3 mt-lg-0">
                                        Copy <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>

                        <!-- Payment Method -->
                        <v-row class="text-center justify-center" v-if="postersBeneficiary">
                            <v-col>
                                <p class="overline my-0">With</p>
                                <v-img
                                    class="mx-auto my-2"
                                    :src="payWithLogo"
                                    tile
                                    :width="isZelleOrInterac ? 100 : 175"
                                    contain
                                ></v-img>
                            </v-col>
                        </v-row>
                    </div>

                    <v-sheet
                        tile
                        :color="isZelleOrInterac ? '#ffffff' : '#f9f9f9'"
                        class="py-6 px-4 grey--text text--darken-3 mx-3 mx-lg-6 mb-6 rounded-lg"
                        :class="[{ 'pt-3 mb-12': isZelleOrInterac }]"
                        v-if="acceptedOrder"
                    >
                        <v-row v-if="postersBeneficiary" class="position-relative">
                            <component :is="paymentComponent" :recipientInfo="recipientInfo"></component>
                        </v-row>
                    </v-sheet>

                    <v-alert type="warning" class="body-2 mb-0 mx-3 mx-lg-0 px-6" text dense>
                        Please note that only complete payments will be accepted.
                        Partial and incomplete payments would not be acknowledged as
                        received and are unacceptable!
                    </v-alert>
                </v-card-text>

                <div class="mx-6 mt-6" v-if="!acceptedOrder.isNgHybrid">
                    <v-switch
                        v-model="showTransferProcessInstructions"
                        color="primary"
                        class="mt-0"
                        style="height: 20px"
                        label="Show Instructions"
                    />
                </div>

                <v-card-actions v-if="postersBeneficiary" class="pa-3 mt-3">
                    <v-btn
                        class="text-capitalize px-6 cancel"
                        text
                        color="red darken-2"
                        large
                        @click="$emit('close')"
                    >
                        Close
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        v-if="!acceptedOrder.order.probably_paid && !acceptedOrder.isNgHybrid"
                        class="text-capitalize px-10 rounded-lg"
                        color="primary"
                        dark
                        depressed
                        large
                        @click="$event => pay()"
                    >
                        Pay
                    </v-btn>
                </v-card-actions>
            </template>
            <transfer-guide
                @proceed="handleTransferGuideOnProceed()"
                :order="acceptedOrder"
                :postersBeneficiary="postersBeneficiary"
                :totalSlides="4"
                v-else
            />
        </template>
        <div class="text-center pa-5" v-else>
            <v-progress-circular
                indeterminate
                color="primary"
                class="ml-2"
            />
        </div>
        <VirtualOrderDisclaimer
            v-model="showVirtualOrderDisclaimer"
            :matcher-payment-provider="matcherPaymentProvider"
        />
    </v-card>
</template>

<script>
    import ServerUtils from '../../../services/ServerUtils';
    let currency = require('../../../modules/currency.js');
    import { sample } from 'lodash';
    // import paypal_payment from '../../match-confirmed-reveal-type-paypal-payment';
    // import nigerian_bank_payment from '../../match-confirmed-reveal-type-nigerian-bank-payment';
    import zelle_payment from '../../match-confirmed-reveal-type-zelle-payment';
    import interac_payment from '../../match-confirmed-reveal-type-interac-payment';
    import faster_payment from '../../match-confirmed-reveal-type-faster-payment';
    import sepa_payment from '../../match-confirmed-reveal-type-sepa-payment';
    import mono_payment from '../../match-confirmed-reveal-type-mono-payment';
    import flutterwave_payment from '../../match-confirmed-reveal-type-flutterwave-payment';
    import unified_api_payment from '../../match-confirmed-reveal-type-unified-api-payment';
    import TransferGuide from './transfer-guide.vue';
    import VirtualOrderDisclaimer from './VirtualOrderDisclaimer.vue';
    import nghybrid_payment from '../../match-confirmed-reveal-type-nghybrid-payment.vue'

    export default {
        props: {
            acceptedOrder: Object,
            couponProp: Object,
            isFromTransfers: {
                type: Boolean,
                default: false,
            },
            skipPaymentMethodCheck: {
                type: Boolean,
                default: false,
            },
        },
        created: created,
        mounted: mounted,
        methods: getMethods(),
        data: data,
        computed: getComputed(),
        components: {
            // paypal_payment: paypal_payment,
            // nigerian_bank_payment: nigerian_bank_payment,
            zelle_payment: zelle_payment,
            interac_payment: interac_payment,
            faster_payment: faster_payment,
            sepa_payment: sepa_payment,
            mono_payment: mono_payment,
            flutterwave_payment,
            unified_api_payment,
            TransferGuide,
            VirtualOrderDisclaimer,
            nghybrid_payment,
        },
    };

    function data(){
        return {
            loading: true,
            postersBeneficiary: null,
            matcherPaymentProvider: null,
            unifiedPaymentUrl: null,
            showCarousel: false,
            showVirtualOrderDisclaimer: false,
        }
    }

    function mounted() {
        const vm = this;
        setupUiElements();

        function setupUiElements(){
            vm.$store.commit('pageHeaderClass', 'rateAlert');
            vm.$store.commit('pageHeaderTitle', 'Make Payment');
            vm.$store.commit('mobileMenuIsVisible', true);
            vm.$store.commit('closeButtonIsVisible', false);
            vm.$store.commit('hideLogoPart', false);
            vm.loading=false;
        }
    }

    function created() {
        this.loading = true;
        this.loadPostersBeneficiary();
        Vue.backendApi().order().getPaymentWindow()
            .then((response) => {
                this.loading = false;
                const paymentWindow = response.data.value;
                this.setClock(this.acceptedOrder.confirmed_at, paymentWindow)
            })
            .catch((err) => {
                this.loading = false;
                this.$swal({
                    type: 'error',
                    title: 'Error loading payment window',
                    text: err
                });
            });
    }

    function getMethods() {
        return {
            getCurrencySymbol,
            loadPostersBeneficiary,
            setClock,
            handleTransferGuideOnProceed() {
                const { isNgHybrid = false } = this.recipientInfo;
                if (isNgHybrid) {
                    return;
                }
                this.$emit('pay', this.recipientInfo)
            },
            pay(useUnifiedApi = true) {
                if (this.acceptedOrder.isNgHybrid) {
                    return;
                }

                const { matcher_payment_provider: service } = this.acceptedOrder;
                const unifiedApiSupported = service === 'worldremit' || service === 'remitly' || service === 'sendwave'
                // todo: this is wrong, eventually need to
                // move transfer-guide out of this component
                if (useUnifiedApi && this.acceptedOrder.type === 'hybrid' && unifiedApiSupported) {
                    this.$emit('pay', {
                        ...this.recipientInfo,
                        useUnifiedApi,
                    });
                    return;
                }

                // if user clicked `pay manually` in case of unified error
                if (!useUnifiedApi) {
                    this.showCarousel = true;
                    return;
                }

                if(!this.showTransferProcessInstructions) {
                    this.$emit('pay', this.recipientInfo);
                    return;
                }

                this.showCarousel = true;
            }
        }

        function getCurrencySymbol(currency_code) {
            return currency.getCurrencySymbol(currency_code);
        }

        function loadPostersBeneficiary() {
            this.loading = true;
            Vue.backendApi().order(this.acceptedOrder.order_id).getPaymentInfo()
              .then((response) => {
                  this.loading = false;
                  this.matcherPaymentProvider = response.data.matcherPaymentProvider;
                  this.postersBeneficiary = response.data.postersBeneficiary;
                  this.unifiedPaymentUrl = response.data.unifiedPaymentUrl;

                  const { type } = this.acceptedOrder;
                  if (type === 'hybrid' && !this.isFromTransfers) {
                    this.pay()
                  }
              })
              .catch((err) => {
                  this.loading = false;
                  this.$swal({
                      type: 'error',
                      title: 'Error loading posters beneficiary',
                      text: err
                  });
              });
        }

        function setClock(start, lengthOfPaymentWindow) {
            let endDate = Vue.moment(start).add(lengthOfPaymentWindow*60, 'seconds');
            let timeRemaining = endDate.diff(Vue.moment(), 'seconds');
            timeRemaining = timeRemaining > 0 ? timeRemaining : 0;
            this.$emit('startTimer', timeRemaining);
        }
    }

    function getComputed() {
        return {
            totalAmount,
            subtotalInPbCurrency,
            matcherCurrency,
            payWithLogo,
            paymentComponent,
            isZelleOrInterac,
            recipientInfo,
            posterBeneficiaryFirstName,
            showTransferProcessInstructions: {
                get() {
                    return !this.$store.state.hideTransferInstructions;
                },
                set(value) {
                    this.$store.dispatch('updateTransferInstructions', !value);
                },
            },
        };

        function posterBeneficiaryFirstName() {
            const [first_name] = this.postersBeneficiary.full_name.split(' ');
            return first_name;
        }

        function isZelleOrInterac() {
            if (!this.postersBeneficiary) {
                return null;
            }

            const { deliveryMethod } = this.postersBeneficiary;
            const { method } = deliveryMethod;

            return deliveryMethod.method === 'ZELLE' || deliveryMethod.method === 'INTERAC';
        }

        function totalAmount() {
            const {
                type,
                matcher_fee: kaoshiFee,
                matcher_amount: matcherAmount,
                matcher_payment_method_fee: matcherPaymentPethodFee,
                pb_to_matcher_exchange_rate: pbToMatcherExchangeRate,
            } = this.acceptedOrder;
            let totalAmount = 0;

            if (type === 'hybrid') {
                totalAmount = parseFloat(matcherAmount)
                    + parseFloat(kaoshiFee/pbToMatcherExchangeRate)
                    + parseFloat(matcherPaymentPethodFee);
            } else {
                totalAmount = parseFloat(kaoshiFee) + parseFloat(matcherAmount);
            }

            return totalAmount.toFixed(2);
        }

        function subtotalInPbCurrency() {
            let amount = parseFloat(this.acceptedOrder.pb_amount) + parseFloat(this.acceptedOrder.matcher_fee || 0);
            return this.formatAmount(amount);
        }

        function matcherCurrency() {
            const matcherCurrency = currency.findCurrency(
                this.acceptedOrder.matcher_currency
            );
            return matcherCurrency;
        }

        function payWithLogo() {
            if (!this.postersBeneficiary && !this.matcherPaymentProvider) {
                return null;
            }

            if (this.matcherPaymentProvider) {
                if (this.matcherPaymentProvider.company) {
                    return this.matcherPaymentProvider.company.logo;
                }
            }

            const { deliveryMethod } = this.postersBeneficiary;
            const { method } = deliveryMethod;

            const imageName = `${method.toLowerCase()}_payment`;
            return this.$_getPaymentLogoPath(this.paymentComponent);
        }

        function paymentComponent() {
            if (!this.postersBeneficiary) {
                return null;
            }

            if (this.acceptedOrder && this.acceptedOrder.isNgHybrid) {
                return 'nghybrid_payment'
            }

            const { deliveryMethod } = this.postersBeneficiary;
            const { provider, method } = deliveryMethod;

            return `${method.toLowerCase()}_payment`;
        }

        function recipientInfo() {
            if(!this.postersBeneficiary) {
                return {};
            }

            if (this.unifiedPaymentUrl) {
                return {
                    paymentUrl: this.unifiedPaymentUrl,
                };
            }

            const { deliveryMethod } = this.postersBeneficiary;
            const {
                provider,
                method,
                institution_name: institutionName,
            } = deliveryMethod;
            let { account } = deliveryMethod;

            if (typeof account == "string") {
                try {
                    account = JSON.parse(account)
                } catch (err) {
                    console.log("could not parse poster beneficiary account")
                }
            }

            if(method === 'ZELLE') {
                return {
                    provider,
                    method,
                    name: account.holder_name,
                    email: account.zelle_email,
                };
            }
            if(method === 'INTERAC') {
                return {
                    provider,
                    method,
                    name: account.holder_name,
                    email: account.interac_email,
                };
            }
            if(method === 'FASTER' && provider === 'PLAID') {
                return {
                    provider,
                    method,
                    name: account.holder_name,
                    account_number: account.account,
                    sort_code: account.sort_code,
                };
            }
            if(method === 'FASTER' && provider === 'KLARNA') {
                return {
                    provider,
                    method,
                    name: account.holder_name,
                    account_number: account.account_number,
                    sort_code: account.bank_code,
                };
            }
            if(method === 'SEPA' && (provider === 'KLARNA' || provider === 'PLAID')) {
                return {
                    provider,
                    method,
                    name: account.holder_name,
                    iban: account.iban,
                    bic: account.bic,
                };
            }

            if(provider === 'MONO') {
                const {
                    full_name: name,
                    email,
                    city,
                    phone,
                } = this.postersBeneficiary;

                if (this.acceptedOrder.isNgHybrid) {
                    return {
                        isNgHybrid: true,
                        provider,
                        method,
                        name,
                        phone,
                        // email,
                        account_number: account.accountNumber,
                        bank_name: institutionName,
                        // company,
                        // city,
                        // state,
                        // zipcode,
                        // address: `${streetNumber} ${address}`,
                        // country,
                    };
                }

                let company = null
                if (this.matcherPaymentProvider) {
                    company = his.matcherPaymentProvider.company
                }

                return {
                    provider,
                    method,
                    name,
                    phone,
                    email,
                    account_number: account.accountNumber,
                    bank_name: institutionName,
                    company,
                    city,
                };
            }

            if(provider === 'FLUTTERWAVE') {
                const {
                    full_name: name,
                    kaoshi_email: email,
                    city,
                    state,
                    zipcode,
                    address,
                    street_number: streetNumber,
                    country,
                    phone,
                } = this.postersBeneficiary;

                let company = null
                if (this.matcherPaymentProvider) {
                    company = his.matcherPaymentProvider.company
                }

                return {
                    provider,
                    method,
                    name,
                    phone,
                    email,
                    account_number: account.account_number,
                    branch_code: account.branch_code,
                    bank_name: institutionName,
                    company,
                    city,
                    state,
                    zipcode,
                    address: `${streetNumber} ${address}`,
                    country,
                };
            }

            if(provider === 'unified_api') {
                const {
                    full_name: name,
                    email,
                    city,
                    phone,
                } = this.postersBeneficiary;
                let company = null
                if (this.matcherPaymentProvider) {
                    company = his.matcherPaymentProvider.company
                }

                return {
                    provider,
                    method,
                    name,
                    phone,
                    email,
                    account_number: account.accountNumber,
                    bank_name: institutionName,
                    company,
                    city,
                };
            }
        }
    }
</script>

<style>
.w-400 {
    width: 400px;
}

.matcher-payment-provider-logo {
    height: 36px;
    background: white;
    margin-left: 1rem;
    border-radius: 4px;
}

</style>

<style scoped>
    #scroller {
        height: 50vh;
        overflow-x: hidden;
        overflow-y: scroll;
    }

    .avatar {
        border-radius: 50%;
        width: 100px;
        height: 100px;
    }

    .arrows {
        height: 105px;
    }

    @media screen and (max-width: 767px) {
        .avatar {
            width: 75px;
            height: 75px;
        }

        .arrows {
            height: 80px;
        }
    }

    .cancel {
        background-color: #FFEDD3;
    }
</style>
